import store from "../store"

export default class DOT {
    export() {
        const graph = store.getState().Graph.present

        let conn = '--', text = ''

        if(graph.directionalEdges) {
            conn = '->'
            text += 'di'
        }

        text += "graph graphname {\n"


        for(let vertex in graph.vertexList)
            text += '\tV_' + vertex + ' [label="' + graph.vertexList[vertex].label + '"];\n'

        text += '\n'

        for(let edge of graph.edgeList) {
            text += '\tV_' + edge.from.id + ' ' + conn + ' V_' + edge.to.id;

            if(edge.name)
                text += ' [label="' + edge.name + '"]';

            text += ';\n';
        }

        text += "}"

        return text
    }
}


// WEBPACK FOOTER //
// ./src/helper/DOT.js